import { GamificationIconType } from '@bg-components/GamificationIcon';
import { GAMIFICATION_TAB } from '@bg-components/Profile/enums';

export const STORAGE_KEY = 'badge_date_seen';

export const INTRO_PAGE_ORDERED_PRESET = [
    {
        buttonText: 'view_challenges',
        id: GAMIFICATION_TAB.CHALLENGES,
        icon: GamificationIconType.BADGE,
    },
    {
        buttonText: 'view_tournaments',
        id: GAMIFICATION_TAB.TOURNAMENTS,
        icon: GamificationIconType.TOURNAMENT,
    },
    {
        buttonText: 'view_shop',
        id: GAMIFICATION_TAB.SHOP,
        icon: GamificationIconType.SHOP,
    },
    {
        buttonText: 'view_inbox',
        id: GAMIFICATION_TAB.INBOX,
        icon: GamificationIconType.INBOX,
    },
];

export const DATA_REFRESH_INTERVALS = {
    TOURNAMENT: 10000, // 10 seconds
    SHOP: 30000, // 30 seconds
};

export const CAPTAIN_UP_LANGUAGE_CONFIG: Record<string, string> = {
    de: 'de-de',
    fr: 'fr-fr',
    es: 'es-es',
    pt: 'pt-pt',
    fi: 'fi-fi',
    ru: 'ru-ru',
    sv: 'sv-se',
    it: 'it-it',
    ee: 'et-ee', // Estonian
    dk: 'da-dk', // Danish
    gr: 'el-gr', // Greek
    ge: 'ka-ge', // Georgian
    xr: 'ar-sa', // Arabic
    bh: 'bg-bg', // Bulgarian
    cg: 'fr-fr', // French (Congo)
    xl: 'es-es', // Spanish (Latin America)
    il: 'he-il', // Hebrew (he-IL)
    zh: 'zh-tw', // Chinese
    zh_hant: 'zh-tw', // Chinese
    ar: 'ar-ma',
    lru: 'ru-ru', // Lotto Russian
    fa: 'fa-ir', // Persian/Farsi
    lt: 'lt-lt',
    no: 'nn-no', // Norwegian
    'pt-br': 'pt-br', // Portuguese
    pt_br: 'pt-br', // Portuguese
};

export const GAMIFICATION_TERMS_AND_CONDITIONS_BLOCK_ORDER = 4;

export const ASSET_EXPIRATION_DAYS = 2;
